import React, { Fragment, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Table from './Table';
import './ShoppingCart.scss';
import { Helmet } from 'react-helmet';
import Layout from './../Layout';
import * as actions from './ShoppingCart.actions';
import * as selectors from './ShoppingCart.selectors';
import { stringifyEqualityCheck } from './../../utils';
import * as loginSelectors from './../Login/Login.selectors';

const Orders = (props) => {
    /* State to props */
    const items = useSelector(selectors.getItems, stringifyEqualityCheck);
    const fetching = useSelector(selectors.getFetching);
    const checking = useSelector(selectors.getChecking);
    const changingQuantity = useSelector(selectors.getChangingQuantity);
    const changingQuantityId = useSelector(selectors.getChangingQuantityId);
    const shippingType = useSelector(selectors.getShippingType);
    const checkingOut = useSelector(selectors.getCheckingOut);
    const checkingId = useSelector(selectors.getCheckingId);
    const user = useSelector(loginSelectors.getUser, stringifyEqualityCheck);
    const cxmlData = useSelector(loginSelectors.getCxmlData, stringifyEqualityCheck);

    /* Dispatch to props */
    const dispatch = useDispatch();
    const fetchItems = useCallback(() => dispatch(actions.fetchItems()), [dispatch]);
    const checkout = useCallback(() => dispatch(actions.checkout()), [dispatch]);
    const deleteItem = useCallback((id) => dispatch(actions.deleteItem(id)), [dispatch]);
    const changeQuantity = useCallback((id, quantity) => dispatch(actions.changeQuantity(id, quantity)), [dispatch]);
    const changeItemQuantity = useCallback((index, value) => dispatch(actions.changeItemQuantity(index, value)), [dispatch]);
    const setShippingType = useCallback((value) => dispatch(actions.setShippingType(value)), [dispatch]);
    const editProduct = useCallback((id, history) => dispatch(actions.editProduct(id, history)), [dispatch]);
    const checkoutItem = useCallback((id, value) => dispatch(actions.checkoutItem(id, value)), [dispatch]);

    /* componentDidMount */
    useEffect(() => {
        fetchItems();
    }, [fetchItems]);

    return (
        <Layout
            title={<Fragment><i className="fas fa-shopping-cart" /> Shopping Cart</Fragment>}
            step={4}
            history={props.history}
        >
            <Helmet><title>Shopping Cart</title></Helmet>
            <div className="shopping-cart-container">
                <h2>Shopping Cart</h2>
                <Table
                    items={items}
                    fetching={fetching}
                    checking={checking}
                    user={user}
                    cxmlData={cxmlData}
                    changingQuantity={changingQuantity}
                    changingQuantityId={changingQuantityId}
                    shippingType={shippingType}
                    checkingOut={checkingOut}
                    checkingId={checkingId}
                    history={props.history}
                    checkout={checkout}
                    deleteItem={deleteItem}
                    changeQuantity={changeQuantity}
                    changeItemQuantity={changeItemQuantity}
                    setShippingType={setShippingType}
                    editProduct={editProduct}
                    checkoutItem={checkoutItem}
                />
            </div>
        </Layout>
    );
};

export default Orders;
